<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-05 23:07:22
 * @Description: file content
 rule rank prize
 规则、排行、奖品
 -->
<template>
  <div class="mymodal" v-show="value">
    <div class="info">
      <!-- <img class="form-title" src="http://assets.rurushishi.com/activies/hhjx-purchase/form1.png" /> -->
      <img class="modalTitle" :src="configInfo.popupStyleImg" />
      <div class="msg-info" >
        <div class="prizeIcon1"><img src="https://assets.rurushishi.com/activies/yy-help-2022-12/prizeIcon1.png" /></div>
        <div class="prizeIcon2"><img src="https://assets.rurushishi.com/activies/yy-help-2022-12/prizeIcon2.png" /></div>
       <template >
          <img class="qrCode" :src="`https://assets.rurushishi.com/activies/yy-help-2022-12/${message.qrCode}`" />
          <div class="code">扫描二维码，关注视频号</div>
          <div class="tip">
          </div>
       </template>
      </div>
      <img class="close" @click="clickClose" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";

export default {
  components: {},
  props: {},
  data() {
    return {
      value: false,
      callback: null,
      message: "",
      configInfo: {},
      text: "",
    };
  },
  watch: {},
  computed: {
  },
  filters: {
     parseTime(time){
      if (arguments.length === 0 || !time) {
        return null
      }
      const format ='{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if (typeof time === 'string') {
          if (/^[0-9]+$/.test(time)) {
            // support "1548221490638"
            time = parseInt(time)
          } else {
            // support safari
            time = time.replace(new RegExp(/-/gm), '/')
          }
        }

        if (typeof time === 'number' && time.toString().length === 10) {
          time = time * 1000
        }
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      return format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        if (key === 'a') {
          return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
      })
    }
  },
  mounted() {
    this.configInfo =this.$configInfo ;
  },
  methods: {
    clickClose() {
      this.value = false;
      this.callback("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
div{
  img{
    width:100%;
  }
}
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  .info {
    position: relative;
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .modalTitle {
      position: relative;
      width: 300px;
      z-index: 1;
    }

    .msg-info {
      position: relative;
      z-index: 0;
      margin-top: -1px;
      margin-left: 1px;
      background: linear-gradient(180deg, #ffeee1, #F8DFC4);
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 0px 0px 16px 16px;
      width: 273px;
      box-sizing: border-box;
      padding-bottom: 24px;
      .prizeIcon1{
        position: absolute;
        right:12px;
        top:0;
        width:30px;
      }
      .prizeIcon2{
        position: absolute;
        left:0;
        top:53px;
        width:26px;
      }

      .msgTitle {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #262626;
      }

      .qrCode {
        width: 160px;
        margin-top: 12px;
      }

      .code {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
        line-height: 35px;
        
        margin-top: 20px;
      }

      .tip {
        width: 240px;
        margin-top: 10px;
        font-size: 12px;
        line-height: 20px;
        color: #595959;
      }

      .submit {
        margin-top: 12px;
        width: 220px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        border-radius: 24px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      }
    }

    .close {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1002;
      margin-top: 28px;
    }
  }
}
</style>
